module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/3-704e2e58e2dedc9bfdfe6810cf516e0d.webp";